import {getAwpClientHeaders} from '../../session/awpRequestHeaders';

// Helper to build fetch headers: AWP user/session tracing + Connection: 'close' under Node.
export default function buildHeaders(base = {}) {
    const awp = getAwpClientHeaders();
    const headers = Object.assign({}, awp, base);
    try {
        const isNode = typeof process !== 'undefined' && !!process.versions && !!process.versions.node;
        if (isNode) {
            headers['Connection'] = 'close';
        }
    } catch (_) {
    }
    return headers;
}
